function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "whitepaper_svg__linear-gradient",
  x1: -1162.08,
  y1: 3931.66,
  x2: -985.58,
  y2: 4509.89,
  gradientTransform: "matrix(1 0 0 -1 1566.31 4557.19)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e2e7f0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "whitepaper_svg__linear-gradient-2",
  x1: -899.01,
  y1: 4049.33,
  x2: -663.25,
  y2: 4625.99,
  gradientTransform: "matrix(1 0 0 -1 1236.9 4674.08)",
  xlinkHref: "#whitepaper_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "whitepaper_svg__linear-gradient-3",
  x1: -630.18,
  y1: 4147.22,
  x2: -336.45,
  y2: 4711.52,
  gradientTransform: "matrix(1 0 0 -1 899.02 4765.79)",
  xlinkHref: "#whitepaper_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "whitepaper_svg__linear-gradient-4",
  x1: -351.61,
  y1: 4226.58,
  x2: -3.14,
  y2: 4768.13,
  gradientTransform: "matrix(1 0 0 -1 554.96 4833.77)",
  xlinkHref: "#whitepaper_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "whitepaper_svg__linear-gradient-5",
  x1: -63.87,
  y1: 4286.12,
  x2: 334.26,
  y2: 4795.32,
  gradientTransform: "matrix(1 0 0 -1 206.56 4877.14)",
  xlinkHref: "#whitepaper_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "whitepaper_svg__linear-gradient-6",
  x1: 232.23,
  y1: 4324.45,
  x2: 673.28,
  y2: 4792.76,
  gradientTransform: "matrix(1 0 0 -1 -144.24 4895.02)",
  xlinkHref: "#whitepaper_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "whitepaper_svg__linear-gradient-7",
  x1: 513.11,
  y1: -483.68,
  x2: 926.37,
  y2: 97.71,
  gradientTransform: "translate(-459.75 504.72)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e1e6ef"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "whitepaper_svg__linear-gradient-8",
  x1: -3413.21,
  y1: -9547.93,
  x2: -2960.33,
  y2: -9547.93,
  gradientTransform: "matrix(-1.12 -.45 -.37 .93 -6878.03 7887.69)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#e1e6ef"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "whitepaper_svg__linear-gradient-9",
  x1: 780.57,
  y1: -178.78,
  x2: 895.76,
  y2: -121.66,
  gradientTransform: "rotate(-3.56 8628.145 7481.1)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#e1e6ef"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "whitepaper_svg__radial-gradient",
  cx: 1000.73,
  cy: 38.57,
  r: 186.93,
  gradientTransform: "rotate(-16.78 1922.443 2538.424)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c9d0e9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#c9d0e9",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "whitepaper_svg__AI_Shadow_2",
  x: "-15%",
  y: "-15%",
  width: "140%",
  height: "130%"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 12,
  in: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  result: "offsetBlurredAlpha",
  dy: 10,
  in: "blur"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "offsetBlurredAlpha"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("style", null, ".whitepaper_svg__cls-1{opacity:.15;filter:url(#whitepaper_svg__AI_Shadow_2)}.whitepaper_svg__cls-5{opacity:.5}.whitepaper_svg__cls-6{fill:#e2e7f0}.whitepaper_svg__cls-15{fill:#303233;fill-rule:evenodd}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-61.98 443.559 380.585)",
  d: "M237.15 140.78H743.5v391.27H237.15z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(28.02 496.383 199.808)",
  fill: "url(#whitepaper_svg__linear-gradient)",
  d: "M294.87 80.69h395.22v511.47H294.87z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-67.24 408.671 375.453)",
  d: "M200.81 140.78h506.35v391.27H200.81z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(22.76 468.226 169.18)",
  fill: "url(#whitepaper_svg__linear-gradient-2)",
  d: "M258.16 80.69h395.22v511.47H258.16z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-72.5 370.268 370.987)",
  d: "M161.14 140.78h506.35v391.27H161.14z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(17.5 441.773 120.428)",
  fill: "url(#whitepaper_svg__linear-gradient-3)",
  d: "M218.09 80.69h395.22v511.47H218.09z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  className: "whitepaper_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-163.05 522.129 152.318)",
  d: "M457.17 145.99h196.32v21.02H457.17z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-163.05 511.544 187.066)",
  d: "M446.58 180.74H642.9v21.02H446.58z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-163.05 500.96 221.814)",
  d: "M435.99 215.49h196.32v21.02H435.99z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "matrix(-.96 -.29 .29 -.96 884.64 644.94)",
  d: "M425.41 250.23h196.32v21.02H425.41z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-163.05 479.785 291.31)",
  d: "M414.82 284.98h196.32V306H414.82z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-163.05 458.616 360.81)",
  d: "M393.64 354.48h196.32v21.02H393.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-163.05 448.026 395.558)",
  d: "M383.06 389.23h196.32v21.02H383.06z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-163.05 437.441 430.306)",
  d: "M372.47 423.97h196.32v21.02H372.47z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-163.05 416.268 499.807)",
  d: "M351.29 493.47h196.32v21.02H351.29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-163.05 405.683 534.555)",
  d: "M340.71 528.22h196.32v21.02H340.71z"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-77.76 333.646 367.044)",
  d: "M123.41 140.78h506.35v391.27H123.41z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(12.24 428.837 30.196)",
  fill: "url(#whitepaper_svg__linear-gradient-4)",
  d: "M179.98 80.69H575.2v511.47H179.98z"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  className: "whitepaper_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(12.35 468.444 226.104)",
  d: "M319.93 519.35h196.32v21.02H319.93z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(12.35 476.2 190.62)",
  d: "M327.7 483.87h196.32v21.02H327.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(12.35 483.956 155.136)",
  d: "M335.46 448.38h196.32v21.02H335.46z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(12.35 491.758 119.647)",
  d: "M343.23 412.9h196.32v21.02H343.23z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(12.35 499.52 84.209)",
  d: "M351 377.41h196.32v21.02H351z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(12.35 515.031 13.24)",
  d: "M366.53 306.44h196.32v21.02H366.53z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(12.35 522.787 -22.244)",
  d: "M374.3 270.96h196.32v21.02H374.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(12.35 530.548 -57.682)",
  d: "M382.06 235.47h196.32v21.02H382.06z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(12.35 546.06 -128.65)",
  d: "M397.6 164.5h196.32v21.02H397.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(12.35 553.862 -164.14)",
  d: "M405.36 129.02h196.32v21.02H405.36z"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-83.02 299.173 363.531)",
  d: "M87.94 140.78h506.35v391.27H87.94z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(6.98 455.987 -195.268)",
  fill: "url(#whitepaper_svg__linear-gradient-5)",
  d: "M144.15 80.69h395.22v511.47H144.15z"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  className: "whitepaper_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-173.26 415.038 130.606)",
  d: "M349.28 127.13H545.6v21.02H349.28z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-173.26 410.77 166.681)",
  d: "M345.02 163.2h196.32v21.02H345.02z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-173.26 406.508 202.756)",
  d: "M340.75 199.28h196.32v21.02H340.75z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-173.26 402.24 238.831)",
  d: "M336.49 235.35h196.32v21.02H336.49z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-173.26 397.977 274.906)",
  d: "M332.23 271.42h196.32v21.02H332.23z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-173.26 389.446 347.05)",
  d: "M323.7 343.57h196.32v21.02H323.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-173.26 385.184 383.126)",
  d: "M319.43 379.65h196.32v21.02H319.43z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-173.26 380.92 419.2)",
  d: "M315.17 415.72h196.32v21.02H315.17z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-173.26 372.39 491.35)",
  d: "M306.64 487.87h196.32v21.02H306.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(-173.26 368.122 527.425)",
  d: "M302.38 523.94H498.7v21.02H302.38z"
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-88.28 267.157 360.36)",
  d: "M55.03 140.78h506.35v391.27H55.03z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(1.72 869.908 -1796.824)",
  fill: "url(#whitepaper_svg__linear-gradient-6)",
  d: "M110.9 80.69h395.22v511.47H110.9z"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  className: "whitepaper_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(1.8 920.356 -1501.528)",
  d: "M286.44 526.06h196.32v21.02H286.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(1.8 921.378 -1537.838)",
  d: "M287.58 489.76H483.9v21.02H287.58z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(1.8 922.399 -1574.147)",
  d: "M288.72 453.45h196.32v21.02H288.72z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(1.8 923.739 -1610.461)",
  d: "M289.86 417.14h196.32v21.02H289.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(1.8 924.76 -1646.77)",
  d: "M291.01 380.83h196.32v21.02H291.01z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "translate(-53.55 -29.97)",
  d: "M293.29 308.22h196.32v21.02H293.29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(1.8 928.143 -1755.704)",
  d: "M294.43 271.91h196.32v21.02H294.43z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(1.8 929.482 -1792.018)",
  d: "M295.57 235.6h196.32v21.02H295.57z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(1.8 931.525 -1864.637)",
  d: "M297.86 162.99h196.32v21.02H297.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-6",
  transform: "rotate(1.8 932.865 -1900.951)",
  d: "M299 126.68h196.32v21.02H299z"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-3.56 -41.095 1353.449)",
  d: "M81.29 82.46h392.48v507.92H81.29z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-3.56 -41.095 1353.449)",
  fill: "url(#whitepaper_svg__linear-gradient-7)",
  d: "M79.31 79.89h396.45v513.05H79.31z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M359.34 413.07c-31.43-66-147.91-30.79-174-64.78-33-43-110-43.89-95 70.73 10.53 80.77 128.34 150.62 145.66 79.46 5.89-24.17 22.76-41.56 49.28-23.08 30.51 21.27 51.83 23.63 69.34 8.3 18.21-15.93 13.47-52.25 4.72-70.63z",
  transform: "translate(-63.76 -17.82)",
  fill: "url(#whitepaper_svg__linear-gradient-8)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M490.34 564.72v-.75l-24 1.49-2.49-39.94 24-1.49-.05-.76-24 1.49-2.49-39.94 24-1.49v-.76l-24 1.49-2.48-39.94 24-1.49v-.75l-24 1.49-2.48-39.95 24-1.49v-.75l-24 1.49-2.49-39.94 24-1.49-.05-.76-24 1.49-2.63-39.97 24-1.49v-.75l-24 1.49-2.48-39.95 24-1.49v-.75l-24 1.49-2.48-39.95 24-1.49-.05-.75-24 1.49-1.84-29.47-.82.05 1.83 29.47-43.84 2.73-1.85-29.75-.83.05 1.85 29.75-43.84 2.73-1.87-30-.83.05 1.87 30-43.85 2.73-1.88-30.31-.83.05 1.89 30.31-43.95 2.76-1.91-30.59-.82.05 1.9 30.59-43.84 2.73-1.92-30.87-.79.09 1.92 30.87-43.92 2.69-1.94-31.15-.83.05 1.94 31.15-43.85 2.73-2-31.43h-.83l2 31.44-43.85 2.73-2-31.71h-.83l2 31.72-13.42.91v.75l13.47-.84 2.49 39.95-13.35.85.05.75 13.43-.84 2.49 39.94-13.4.83v.76l13.43-.83 2.49 39.94-13.36.83.05.76 13.33-.85L98 425l-13.32.83v.75l13.32-.87 2.49 40-13.29.82.05.76 13.28-.83 2.49 39.94-13.25.82v.76l13.24-.82 2.49 39.94-13.21.82.05.75 13.21-.82 2.48 40-13.03.72v.75l13.17-.82.88 14.18h.83l-.88-14.23 43.84-2.73.89 14.33h.83l-.89-14.33 43.84-2.73.9 14.47h.83l-.9-14.47 43.85-2.73.91 14.62h.82l-.92-14.77 43.85-2.73.92 14.76h.83l-.92-14.76 43.84-2.73.93 14.91h.83l-.93-14.91 43.84-2.73.94 15h.83l-.96-15.15 43.88-2.77.94 15.2h.83l-.95-15.2 43.85-2.73.95 15.34.83-.05-.95-15.34zM463 524.81l-43.85 2.73-2.48-39.94 43.84-2.73zm-186.29-111l-43.84 2.73-2.49-39.95 43.85-2.72zm-1.66-40l43.85-2.72 2.48 39.94-43.84 2.73zm1.71 40.75l2.49 40-43.85 2.73-2.49-39.95zm.83 0l43.84-2.73 2.49 39.95-43.92 2.71zm44.67-2.78l43.81-2.78 2.49 40-43.84 2.73zm-.05-.75l-2.48-39.94 43.84-2.73 2.43 39.92zm-2.53-40.7l-2.49-39.94 43.81-2.75 2.48 39.94zm-.83.05L275 373.09l-2.49-39.94 43.85-2.73zm-44.67 2.78l-43.85 2.73-2.48-39.94 43.84-2.73zm-44.67 2.78l-43.85 2.73-2.48-39.94L227 336zm0 .76l2.49 39.92-43.84 2.73-2.49-40zm2.54 40.69l2.48 39.95-43.84 2.73-2.49-39.95zm2.53 40.7l2.5 39.91-43.85 2.73-2.49-39.94zm.83-.05l43.84-2.73 2.49 39.94L237.9 498zm44.67-2.78l43.84-2.73 2.49 39.95-43.85 2.72zm44.67-2.78l43.85-2.73 2.48 39.95-43.84 2.72zm44.67-2.78l43.86-2.7 2.49 39.95-43.85 2.72zm0-.75L366.9 409l43.85-2.73 2.48 39.95zm-2.54-40.7l-2.48-39.94 43.84-2.73 2.49 39.94zm-2.53-40.7l-2.48-39.94 43.84-2.73 2.49 39.94zm-2.53-40.7l-2.49-39.94 43.85-2.73 2.49 39.95zm-.83.06l-43.84 2.72-2.49-39.94 43.85-2.73zm-44.67 2.78l-43.85 2.72-2.47-39.96 43.84-2.73zm-44.67 2.78l-43.85 2.72-2.48-39.94 43.84-2.73zM227 335.23L183.1 338l-2.49-40 43.85-2.73zM182.27 338l-43.84 2.73-2.49-39.94 43.85-2.73zm0 .76l2.49 39.94-43.76 2.73-2.49-39.94zm2.53 40.7l2.49 39.94-43.85 2.73-2.44-39.95zm2.54 40.69l2.48 40-43.82 2.68-2.49-39.95zm2.53 40.7l2.48 39.94-43.84 2.73-2.49-39.94zm2.53 40.7l2.49 39.94-43.85 2.73-2.49-39.94zm.83-.05l43.84-2.73 2.49 39.94-43.85 2.73zm44.77-2.78l43.79-2.72 2.49 39.94-43.85 2.73zm44.67-2.78l43.85-2.73 2.48 39.94-43.84 2.73zm44.67-2.78l43.85-2.73 2.48 39.94-43.84 2.73zm44.66-2.78l43.84-2.73 2.49 39.94-43.85 2.73zm88.47-6.26l-43.85 2.72-2.48-39.94 43.86-2.73zm-2.54-40.7l-43.84 2.73-2.49-39.95 43.85-2.73zm-2.53-40.7l-43.84 2.73-2.56-39.94 43.85-2.73zM452.84 362L409 364.75l-2.48-39.94 43.84-2.73zm-2.53-40.69l-43.85 2.72-2.46-39.92 43.84-2.73zm-5-80.64l2.49 39.94-43.85 2.73-2.49-40zm-44.67 2.78l2.48 39.94-43.84 2.73-2.49-39.95zm-44.68 2.77l2.49 39.95-43.84 2.73-2.49-40zM311.27 249l2.49 40-43.85 2.73-2.48-39.95zm-44.67 2.8l2.49 39.95-43.85 2.73-2.49-40zm-44.67 2.78l2.48 39.95-43.84 2.73-2.49-39.95zm-44.67 2.78l2.48 39.95L135.9 300l-2.49-40zm-88.52 5.51l43.84-2.73 2.49 39.95-43.85 2.73zm2.53 40.7l43.85-2.73 2.48 39.94-43.84 2.73zm2.53 40.7l43.85-2.73 2.48 39.94-43.84 2.73zM96.34 385l43.84-2.72 2.49 39.94-43.85 2.73zm2.53 40.7l43.84-2.73 2.49 39.95-43.85 2.73zm2.53 40.7l43.85-2.73 2.48 39.94-43.84 2.73zm2.53 40.7l43.85-2.73 2.48 39.94-43.84 2.69zm5 80.64l-2.49-40 43.87-2.74 2.49 40zm44.67-2.78L151.14 545l43.86-2.75 2.49 39.94zm44.67-2.78l-2.48-39.95 43.84-2.72 2.49 39.94zm44.73-2.82l-2.49-40 43.85-2.72 2.48 39.94zm44.67-2.78l-2.49-40 43.82-2.67 2.48 39.94zm44.67-2.78l-2.48-39.95 43.84-2.72 2.49 39.94zM377 571l-2.48-39.95 43.84-2.72 2.49 39.94zm44.68-2.78l-2.49-39.94 43.81-2.71 2.48 39.94z",
  transform: "translate(-63.76 -17.82)",
  fill: "url(#whitepaper_svg__radial-gradient)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M427.54 562.32l-23.97 1.41-.83.05-43.85 2.59-.83.05-43.85 2.58-.83.05-43.85 2.59-.83.05-43.85 2.58-.83.05-43.86 2.59-.82.05-43.86 2.58-.83.05-43.85 2.59-.83.05-43.85 2.58-.83.05-13.16.78-.89-14.14-.05-.75-2.52-39.95-.05-.75-2.52-39.94-.05-.76-2.52-39.93-.05-.76-2.52-39.94-.05-.75-2.52-39.94-.05-.76-2.52-39.94-.05-.76-2.52-39.93-.05-.75-2.52-39.95-.05-.75-2.01-31.8 13.51-.76.83-.04 43.86-2.46.83-.04 43.86-2.45.83-.05 43.86-2.45.83-.05 43.86-2.45.82-.05 43.87-2.45.83-.05 43.86-2.45.83-.05 43.86-2.45.83-.05 43.86-2.45.82-.05 23.98-1.34 1.82 29.32.05.75 2.49 39.95.04.75 2.49 39.95.05.75 2.48 39.94.05.76 2.48 39.94.05.75 2.49 39.95.04.75 2.49 39.94.05.76 2.48 39.94.05.76 2.48 39.94.05.75.96 15.42z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M406.45 357.14c-10.81 17.69-26.25 25.21-39 23.77s-18.18-17-7.37-34.71 24.72-32.51 39.94-27.59c12.17 3.92 17.24 20.84 6.43 38.53z",
  transform: "translate(-63.76 -17.82)",
  fill: "url(#whitepaper_svg__linear-gradient-9)"
});

var _ref24 = /*#__PURE__*/React.createElement("g", {
  id: "whitepaper_svg__Artwork"
}, /*#__PURE__*/React.createElement("g", {
  id: "whitepaper_svg__logo_dark",
  "data-name": "logo dark"
}, /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-15",
  d: "M135.64 566.22l-.14-2.22 6.61-.41v.8a6 6 0 01-5.73 6.51 6.31 6.31 0 11-.88-12.59 6.39 6.39 0 015.87 2.79l.07.11-2.19 1.5-.08-.12a3.58 3.58 0 00-3.5-1.79 3.8 3.8 0 00-3.58 4 3.78 3.78 0 004.14 3.57 3.23 3.23 0 003.15-2.4zm12.43-4.75a2.68 2.68 0 00-.69-.05 2.41 2.41 0 00-2.11 1.34l-.07-1.12-2.49.16.51 8.31 2.58-.16-.22-3.63c-.11-1.66.79-2.32 1.82-2.38a3.75 3.75 0 01.82 0l-.16-2.5zm8.93 3.47a3.92 3.92 0 00-4.49-4 4.22 4.22 0 00-3.93 4.64 4.27 4.27 0 004.67 4.16 3.78 3.78 0 003.71-2.89l-2.19-.46a1.63 1.63 0 01-1.63 1.19 1.82 1.82 0 01-2-1.49l5.86-.36a7 7 0 000-.79zm-5.91-.49a1.6 1.6 0 011.59-1.51 1.51 1.51 0 011.78 1.3zm9.38 4.55l-.3-4.77a1.37 1.37 0 011.3-1.53 1.28 1.28 0 011.45 1.32l.3 4.82 2.54-.16-.3-4.8a1.36 1.36 0 011.32-1.51 1.27 1.27 0 011.43 1.32l.29 4.81 2.5-.15-.34-5.38a3.17 3.17 0 00-5.84-1.52 2.64 2.64 0 00-2.58-1.15 3 3 0 00-2.35 1.36l-.06-1-2.45.16.51 8.3z",
  transform: "translate(-63.76 -17.82)"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-15",
  d: "M110.68 550.34l-.75-12.1-2.59.16.75 12.1 2.59-.16zm3.4-.21l-.51-8.31-2.57.16.52 8.31 2.56-.16z"
}), /*#__PURE__*/React.createElement("path", {
  className: "whitepaper_svg__cls-15",
  d: "M174.4 557.38a1.5 1.5 0 001.59 1.39 1.49 1.49 0 00-.19-3 1.51 1.51 0 00-1.4 1.61zM181 563a1.36 1.36 0 011.3-1.55 1.3 1.3 0 011.46 1.36l.3 4.78 2.57-.16-.32-5.22c-.11-1.82-1.16-3.25-3.28-3.12a2.81 2.81 0 00-2.28 1.32l-.06-.95-2.49.15.52 8.31 2.57-.16z",
  transform: "translate(-63.76 -17.82)"
})));

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 98.5,
  y: 120.27,
  width: 71.67,
  height: 16.17,
  rx: 2.07,
  transform: "rotate(-3.56 -184.238 1145.276)",
  stroke: "#3fb782",
  strokeMiterlimit: 10,
  strokeWidth: 0.65,
  fill: "none"
});

function SvgWhitepaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "whitepaper_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 723.32 637.19"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

export default __webpack_public_path__ + "static/whitepaper.e9864c35.svg";
export { SvgWhitepaper as ReactComponent };